import React from "react";
import { saveAs } from "file-saver";
import formatDate from "../../components/functions/formatDate";
import ExcelJS from "exceljs";

function isActionToExecute(description) {
    return description.trim().toLowerCase().startsWith("исполнить");
}
function formatFioToShort(fio) {
    if (!fio) return "";

    const cleaned = fio.trim();
    const parts = cleaned.split(/\s+/);
    const surname = parts[0];

    // Оставляем как есть, если уже в формате "Фамилия И.О."
    if (/^[А-ЯЁ][а-яё-]+ [А-ЯЁ]\.[А-ЯЁ]\.?$/u.test(cleaned)) {
        return cleaned;
    }

    const initials = parts.slice(1, 3) // берём максимум два
        .map(p => p[0]?.toUpperCase() + ".")
        .join("");

    return `${surname} ${initials}`;
}
function isActionToControl(description){
    return description.trim().toLowerCase().startsWith("контролировать исполнение");
}
function prepareTextForExport(description) {
    if (!description) return '';
    return description.replace(/\. /g, '.\n').trim();
}

const downloadXlsxFromJson = async (json) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Документы");

    // 💡 Устанавливаем стили для заголовков
    const headerStyle = {
        font: { bold: true, size: 10 }, // ✅ Уменьшаем шрифт
        alignment: { vertical: "middle", horizontal: "center", wrapText: true },
        fill: { type: "pattern", pattern: "solid", fgColor: { argb: "CCCCCC" } }
    };

    // 📌 Добавляем заголовки
    sheet.columns = [
        { header: "№", key: "number", width: 5 },
        { header: "Имя", key: "name", width: 20 },
        { header: "Создана", key: "created", width: 10 },
        { header: "Автор", key: "author", width: 20 },
        { header: "Визы", key: "approvals", width: 40 },
        { header: "Исполнители", key: "exec", width: 40 },
        { header: "Выполнено", key: "yea", width: 40 },
        { header: "В работе", key: "no", width: 30 },
        { header: "Контроль", key: "controller", width: 40 }
    ];

    // ✅ Применяем стили к заголовкам
    sheet.getRow(1).eachCell(cell => {
        cell.style = headerStyle;
    });

    // 📌 Добавляем данные с переносами строк и авто-высотой
    json.forEach((doc, index) => {
        const richApprovals = []

        doc.vizas.forEach((viza, i) => {
            richApprovals.push({ text: formatFioToShort(viza.Исполнитель) || '' , font: { size: 9 }});
            richApprovals.push({ text: '\n' });
            // Согласование — жирным
            if (viza.РезультатСогласования) {
                richApprovals.push({
                    text: viza.РезультатСогласования || '',
                    font: { bold: true,size: 9 }
                });
                richApprovals.push({ text: '\n',font: { size: 9 } });
            }
            // Комментарий — обычный
            if (viza.Комментарий) {
                richApprovals.push({ text: viza.Комментарий || '',font: { size: 9 } });
                richApprovals.push({ text: '\n' });
            }
        });
        console.log(richApprovals)
        const row = sheet.addRow({
            number: index + 1,
            name: doc.Description,
            created: formatDate(doc.ДатаСоздания),
            author: formatFioToShort(doc.Создал_Key),
            approvals: "",
            // ✅ Строка с ФИО исполнителей
            exec: doc.processes.length
                ? doc.processes[0].Исполнители.map((ex) => ex.fio).join("\n")
                : "",

            // ✅ Первый комментарий истории, если есть
            yea:
                doc.processes.length &&
                doc.processes[0].Исполнители[0]?.history?.[0]?.Описание || "",

            // ✅ Комментарии с действиями (начинаются с "Исполнить" и не выполнены)
            no: doc.processes.length
                ? doc.processes[0].Исполнители[0]?.comments
                    ?.map((comment) =>
                        !comment.Executed && isActionToExecute(comment.Description)
                            ? `${comment.fio}. ${
                                comment.РезультатВыполнения?.length
                                    ? comment.РезультатВыполнения
                                    : "без комментария"
                            }`
                            : null
                    )
                    .filter(Boolean)
                    .join("\n")
                : "",
            // ✅ Комментарии по контролю (всё остальное)
            controller: doc.processes.length
                ? doc.processes[0].Исполнители[0]?.comments
                    ?.map((comment) =>
                        isActionToControl(comment.Description)
                            ? `${comment.fio}.\n${
                                comment.РезультатВыполнения?.length
                                    ? comment.РезультатВыполнения
                                    : "без комментария"
                            }\n${comment.Executed ? "Контроль пройден" : "Контроль не пройден или заявка не исполнена"}`
                            : null
                    )
                    .filter(Boolean)
                    .join("\n")
                : ""
        })
        row.getCell(5).value = { richText: richApprovals ? richApprovals : '' };
        // ✅ Применяем стили к ячейкам
        row.eachCell(cell => {
            cell.style = {
                font: { size: 9 }, // ✅ Уменьшаем шрифт текста в ячейках
                alignment: { vertical: "middle", horizontal: "center", wrapText: true } // ✅ Центрируем содержимое
            }
        })
    })

    // 📌 Генерируем файл и скачиваем
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), `Документы_${new Date().toISOString().split("T")[0]}.xlsx`);
}
export default downloadXlsxFromJson